
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { AppState } from 'src/store';
import { Row, Card, Tabs, Button, Modal, Input, Tooltip, message } from 'antd';
import { MerchantSummary, MemberList, OfferList, StampList, RewardList, UserList, Points, Boosts } from '.';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs';

const TabPane = Tabs.TabPane;

class ClearDataButton extends React.Component<{
    merchantId: string,
    handler: (merchantId: string) => void
}> {
    onPress = () => {
        const { merchantId, handler } = this.props;
        handler(merchantId);
    }

    render() {
        return (
            <Tooltip placement="top" title="Click to clear merchant data">
                <Button
                    onClick={this.onPress}
                    icon="delete"
                />
            </Tooltip>
        );
    }
}

const mapStateToProps = ({ authState }: AppState, { match: { params: { id } } }: Props) => {
    let userId: string;
    if (authState.status === 'loggedIn') {
        const { userInfo } = authState;
        userId = userInfo ? userInfo.userId : ''
        return {
            id,
            userId,
        };
    }

    return {
        id,
        userId: '',
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

interface Props extends RouteComponentProps<{ id: string | null }> {
    id: string;
    userId: string;
}

interface S {
    confirmMerchantId?: string;
    currentTab: string;
    showModal: boolean;
    disabledDeleteButton: boolean;
    clearing: boolean;
}

class ViewMerchant extends React.Component<Props, S> {

    constructor(props: Props) {
        super(props);
        this.state = { currentTab: 'member', showModal: false, disabledDeleteButton: true, clearing: false };
    }

    handleTabChange = (tab: string) => {
        this.setState({ currentTab: tab });
    }

    onShowModlal = () => {
        // const { id } = this.props;
        this.setState({ showModal: true });
    }

    handleModalOk = async () => {
        try {
            const { id: merchantId, userId } = this.props;
            this.setState({ clearing: true });
            const clearMerchantData = firebase.functions().httpsCallable('clearMerchantData');
            const httpResult = await Observable
                .defer(() => clearMerchantData({ id: merchantId, userId }))
                .retry(5)
                .toPromise();
            const rewardResult = httpResult.data as {
                success: boolean, error: string, merchantId: string;
            };
            if (rewardResult.success) {
                this.setState({ showModal: false, clearing: false });
                message.success(`You have successfully cleared data for ${merchantId}`);
            } else {
                this.setState({ showModal: false, clearing: false });
                message.error(rewardResult.error);
                // throw new SubmissionError({ code: rewardResult.error });
            }
        } catch (err) {
            this.setState({ showModal: false, clearing: false });
            message.error(err);
            // throw new SubmissionError({ code: err });
        }
    }

    handleModalCancel = () => {
        this.setState({ showModal: false });
    }

    // tslint:disable-next-line:no-any
    handleChange = (e: any) => {
        const { id } = this.props;
        const value = e.target.value;
        this.setState({ disabledDeleteButton: id === value ? false : true });
    }

    render() {
        const { id } = this.props;

        return (
            <div>
                <Row>
                    {id ?
                        <MerchantSummary
                            merchantId={id}
                        /> : ''
                    }
                </Row>
                <Card
                    bordered={true}
                    bodyStyle={{ padding: 0 }}
                    extra={
                        <ClearDataButton merchantId={id} handler={this.onShowModlal} />}
                >
                    <Tabs
                        activeKey={this.state.currentTab}
                        onChange={this.handleTabChange}
                    >
                        <TabPane key="member" tab="Members">
                            <MemberList
                                merchantId={id}
                            />
                        </TabPane>
                        <TabPane key="offer" tab="Offers">
                            <OfferList
                                merchantId={id}
                            />
                        </TabPane>
                        <TabPane key="boost" tab="Boosts">
                            <Boosts
                                merchantId={id}
                            />
                        </TabPane>
                        <TabPane key="stamp" tab="Stamps">
                            <StampList
                                merchantId={id}
                            />
                        </TabPane>
                        <TabPane key="rewars" tab="Rewards">
                            <RewardList
                                merchantId={id}
                            />
                        </TabPane>
                        <TabPane key="point" tab="Points">
                            <Points
                                merchantId={id}
                            />
                        </TabPane>
                        <TabPane key="user" tab="Users">
                            <UserList
                                merchantId={id}
                            />
                        </TabPane>
                    </Tabs>
                    <Modal
                        title="Clear data for this merchant?"
                        visible={this.state.showModal}
                        width={600}
                        onOk={this.handleModalOk}
                        okType='danger'
                        onCancel={this.handleModalCancel}
                        footer={[
                            <Button key="back" onClick={this.handleModalCancel}>
                                Cancel
                            </Button>,
                            <Button
                                key="submit"
                                type="primary"
                                onClick={this.handleModalOk}
                                disabled={this.state.disabledDeleteButton}
                                loading={this.state.clearing}
                            >
                                Clear
                            </Button>,
                        ]}
                    >
                        <p>Doing so will permanently delete the transaction data at this merchant, including all members.</p>
                        <p>Confirm you want to delete this merchant by typing its ID: <span
                            id="textSpan"
                            style={{ fontWeight: 'bold' }}
                        >
                            {id}
                        </span></p>
                        <Input placeholder={id} onChange={this.handleChange} />
                    </Modal>
                </Card>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewMerchant);


// WEBPACK FOOTER //
// ./src/merchants/forms/ViewMerchant.tsx